import { render, staticRenderFns } from "./add-ad-keyword.vue?vue&type=template&id=167a6508&scoped=true&"
import script from "./add-ad-keyword.vue?vue&type=script&lang=js&"
export * from "./add-ad-keyword.vue?vue&type=script&lang=js&"
import style0 from "./add-ad-keyword.vue?vue&type=style&index=0&id=167a6508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167a6508",
  null
  
)

export default component.exports